import React, { useEffect, useState } from "react";

import "./App.css";
import AdminApp from "./AdminApp";
import LoginPanel from "./LoginPanel";
import PasswordSetupPanel from "./PasswordSetupPanel";
import { ADMIN_APP_TITLE } from "./appConfig";
import { hasSupabaseEnv, supabase } from "./supabaseClient";

function isPasswordSetupFlow() {
  if (typeof window === "undefined") {
    return false;
  }

  return new URLSearchParams(window.location.search).get("authFlow") === "password-setup";
}

function clearPasswordSetupUrl() {
  if (typeof window === "undefined") {
    return;
  }

  window.history.replaceState({}, document.title, window.location.origin + window.location.pathname);
}

function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [passwordSetupFlow, setPasswordSetupFlow] = useState(isPasswordSetupFlow);

  useEffect(() => {
    document.title = ADMIN_APP_TITLE;
  }, []);

  useEffect(() => {
    if (!hasSupabaseEnv || !supabase) {
      setLoading(false);
      return undefined;
    }

    let isMounted = true;

    supabase.auth.getSession().then(({ data }) => {
      if (!isMounted) {
        return;
      }

      setSession(data.session || null);
      setLoading(false);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, nextSession) => {
      if (event === "PASSWORD_RECOVERY") {
        setPasswordSetupFlow(true);
      }

      setSession(nextSession || null);
      setLoading(false);
    });

    return () => {
      isMounted = false;
      subscription.unsubscribe();
    };
  }, []);

  async function handleSignOut() {
    if (supabase) {
      await supabase.auth.signOut();
    }
  }

  function handlePasswordSetupComplete() {
    clearPasswordSetupUrl();
    setPasswordSetupFlow(false);
  }

  function handlePasswordSetupBackToLogin() {
    clearPasswordSetupUrl();
    setPasswordSetupFlow(false);
  }

  if (loading) {
    return (
      <div className="auth-page">
        <div className="auth-card auth-card--compact">
          <p className="auth-description">Laddar session...</p>
        </div>
      </div>
    );
  }

  if (passwordSetupFlow) {
    return (
      <PasswordSetupPanel
        hasSession={Boolean(session)}
        onComplete={handlePasswordSetupComplete}
        onBackToLogin={handlePasswordSetupBackToLogin}
      />
    );
  }

  if (!session) {
    return <LoginPanel />;
  }

  return <AdminApp session={session} onSignOut={handleSignOut} />;
}

export default App;
